import { query } from '@/services/graphql';
import * as operations from './operations';

export default {
  getProjectList(variables = {}) {
    return query(operations.PROJECT_LIST, variables, true);
  },
};
